<template>
  <button @click="$emit('click')" class="btn btn-dark gallery-fullscreen-trigger">
    {{ t('gallery.buttons.action') }}
  </button>
</template>

<script>
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'GalleryFullscreenButton',
  emits: ['click'],
  setup() {
    const { t } = useI18n()

    return {
      t
    }
  }
})
</script>

<style lang="scss" scoped>
.gallery-fullscreen-trigger {
  z-index: 2;
}
</style>
